import { Inject } from "inversify-props";
import { AxiosRequestConfig } from "axios";
import { Page } from "@/models";
import { CartaDeCorrecao } from "@/models/fiscal/CartaDeCorrecao";
import { CartaDeCorrecaoServiceAdapter } from "./adapter/CartaDeCorrecaoServiceAdapter";
import { imprimirCartaCorrecao } from "@/shareds/venda-shareds";

export class CartaDeCorrecaoUseCase {
	
	@Inject('CartaDeCorrecaoServiceAdapter')
	private cartaDeCorrecaoServiceAdapter!: CartaDeCorrecaoServiceAdapter

	async criarCartaDeCorrecao(params?: any): Promise<void> {
		await this.cartaDeCorrecaoServiceAdapter.criarCartaDeCorrecao(params);
	}

	async findCartasDeCorrecao(params?: any, config?: AxiosRequestConfig): Promise<Page<CartaDeCorrecao>> {
		return this.cartaDeCorrecaoServiceAdapter.findCartasDeCorrecao(params, config);
	}

	imprimirCartaCorrecao = async (cartaCorrecao: CartaDeCorrecao): Promise<any> =>
		imprimirCartaCorrecao(cartaCorrecao)
}